import { render, staticRenderFns } from "./AddGoal.vue?vue&type=template&id=16131546&scoped=true&lang=pug"
import script from "./AddGoal.vue?vue&type=script&lang=js"
export * from "./AddGoal.vue?vue&type=script&lang=js"
import style0 from "./AddGoal.vue?vue&type=style&index=0&id=16131546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16131546",
  null
  
)

export default component.exports